import { takeLatest, put, call } from "redux-saga/effects";
import { addPatientAPI, addPatientMultipleAPI, updatePatients } from "./PatientAPI";
import { PatientModel } from "../../Services/Models/Patient/PatientModel";
import { patientsActions } from "./reducer";
import { toast } from "react-toastify";

// function* onGetPatientsDetails({ payload: id }: any) {
//   try {
//     const response: PatientModel = yield call(getPatientDetails, id);
//     yield put(getPatientDetailsSuccess(response));
//   } catch (error: any) {
//     yield put(getPatientDetailsFail(error));
//   }
// }

function* onAddPatient({ payload: patient }: any) {
  try {
    const response: PatientModel = yield call(addPatientAPI, patient);
    yield put(patientsActions.addPatientsSuccess(response));
  } catch (err: any) {
    yield put(patientsActions.addPatientsFailed(err));
    toast.error("Error: "+ err.message);
  }
}

function* onAddPatientMultiple({ payload: patient }: any) {
  try {
    const response: PatientModel[] = yield call(addPatientMultipleAPI, patient);
    yield put(patientsActions.addPatientsMultipleSuccess(response));
  } catch (err: any) {
    yield put(patientsActions.addPatientsFailed(err));
    toast.error("Error: "+ err.message);
  }
}

function* onUpdatePatients({payload: patient}: any){
  try{
    const response: PatientModel[] = yield call(updatePatients, patient);
    yield put(patientsActions.updatePatientsSuccess(response));
  }catch(err: any){
    yield put(patientsActions.updatePatientsFailed(err));
    toast.error("Error: "+ err.message);
  }
}

function* PatientSaga() {
  // yield takeLatest(GET_PATIENT_DETAILS, onGetPatientsDetails);
  yield takeLatest(patientsActions.addPatients.type, onAddPatient);
  yield takeLatest(patientsActions.addPatientsMultiple.type, onAddPatientMultiple);
  yield takeLatest(patientsActions.updatePatients.type, onUpdatePatients);
}

export default PatientSaga;
